import { render, staticRenderFns } from "./BIParameterRuleForm.vue?vue&type=template&id=36332d29&"
import script from "./BIParameterRuleForm.vue?vue&type=script&lang=js&"
export * from "./BIParameterRuleForm.vue?vue&type=script&lang=js&"
import style0 from "./BIParameterRuleForm.vue?vue&type=style&index=0&id=36332d29&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports